import { ProjectPicture } from "../../../../components/elements/project-picture"

const StartProjects = ({model}) => {

  return (
    <>
      <ProjectPicture
        node={model.nodes["picture1"]}
        message="Please contact me for more details."
      />
      <ProjectPicture
        node={model.nodes["picture2"]}
        message="Link successfully copied"
        link="https://www.wilson.com/en-us/explore/football/wilson-live"
      />
      <ProjectPicture
        message="Please contact me for more details."
        node={model.nodes["picture3"]}
      />
      <ProjectPicture
        message="Please contact me for more details."
        node={model.nodes["picture4"]}
      />
      <ProjectPicture
        message="Please contact me for more details."
        node={model.nodes["picture5"]}
      />
      <ProjectPicture
        node={model.nodes["picture6"]}
        message="Link successfully copied"
        link="https://kidzify.ai/"
      />
      <ProjectPicture
        node={model.nodes["picture7"]}
        message="Link successfully copied"
        link="https://osvitaveteraniv.gov.ua/"
      />
      <ProjectPicture
        node={model.nodes["picture8"]}
        message="Link successfully copied"
        link="https://codeup.app/"
      />
    </>
  )
}

export {
  StartProjects
}